export const GIFT_REDEEM_PAGE_STATIC_KEY = 'giftRedeemPage'
export default GIFT_REDEEM_PAGE_STATIC_KEY
